import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import userManageService from "../../services/userManageService";
import Breadcrumb from "../../components/Breadcrumbdashboard";

const localCacheKey = "customerReadCache";

export default function ReadCustomers() {
  const navigate = useNavigate();

  const columns = [
  "sl",
  "username",
  "email",
  "phone_number",
  "gender",
  "dob",
  "age",
  "is_active",
];
  const [cachedData, setCachedData] = useState(() => {
    const cache = localStorage.getItem(localCacheKey);
    return cache ? JSON.parse(cache) : null;
  });

  const [localData, setLocalData] = useState(cachedData?.customers || []);
  const [loading, setLoading] = useState(!cachedData);

  const showSwal = useCallback((title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
      customClass: { confirmButton: "btn btn-primary" },
      buttonsStyling: false,
    });
  }, []);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await userManageService.getAllCustomers();
      console.log(res);
      const customers = res.data.customers || [];

      const newCache = { customers };
      const existingCache = localStorage.getItem(localCacheKey);
      const parsedCache = existingCache ? JSON.parse(existingCache) : null;

      if (!parsedCache || JSON.stringify(parsedCache.customers) !== JSON.stringify(customers)) {
        localStorage.setItem(localCacheKey, JSON.stringify(newCache));
        setCachedData(newCache);
      }

      setLocalData(customers);
    } catch (error) {
      console.error("Failed to load users:", error);
      showSwal("Error", "Failed to load user data.", "error");
    } finally {
      setLoading(false);
    }
  }, [showSwal]);

  useEffect(() => {
    if (cachedData) {
      setLocalData(cachedData.customers);
      setLoading(false);
      loadData(); // background refresh
    } else {
      loadData();
    }
  }, [cachedData, loadData]);

  const updateLocalDataCache = (updatedCustomers) => {
    const newCache = { customers: updatedCustomers };
    setLocalData(updatedCustomers);
    setCachedData(newCache);
    localStorage.setItem(localCacheKey, JSON.stringify(newCache));
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: "btn btn-primary m-1",
        cancelButton: "btn btn-danger m-1",
      },
      buttonsStyling: false,
    });

    if (confirm.isConfirmed) {
      try {
        await userManageService.deleteCustomer(id);
        const updated = localData.filter((item) => item.id !== id);
        updateLocalDataCache(updated);
        showSwal("Deleted!", "User has been deleted.", "success");
      } catch (error) {
        console.error("Delete error:", error);
        showSwal("Error", "Failed to delete user.", "error");
      }
    }
  };

  const handleToggleStatus = useCallback(
    async (item) => {
      try {
        await userManageService.toggleCustomerStatus(item.id);
        const updated = localData.map((customer) =>
          customer.id === item.id ? { ...customer, is_active: !customer.is_active } : customer
        );
        updateLocalDataCache(updated);
        showSwal("Success!", "Customer status updated.", "success");
      } catch (error) {
        console.error("Status update failed:", error);
        showSwal("Error!", "Failed to update user status.", "error");
      }
    },
    [localData, showSwal]
  );

  return (
    <DashboardWrapper>
     <div className="container-fluid mt-4">
         <div className="d-flex justify-content-between align-items-center mb-1">
         <h4 className="mb-0">User Management</h4>
        <Breadcrumb/>
          {/* <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/admin/customer/create")}
          >
            Create Customer
          </button> */}
        </div>

        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            {/* <h4 className="mb-0">Customer Management</h4> */}
              <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/admin/customer/create")}
          >
            Create User
          </button>
          </div>

          <div className="card-body">

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
          <CrudTable
  data={localData.map((item, index) => {
    const age = item.dob
      ? new Date().getFullYear() - new Date(item.dob).getFullYear()
      : "";

    return {
      ...item,
      sl: index + 1,
      age,
    };
  })}
              onEdit={(row) => navigate(`/admin/customer/edit/${row.id}`)}
              onDelete={handleDelete}
              onToggleStatus={handleToggleStatus}
              columns={columns}
            />
          )}
        </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
